import axios from "axios";
import {
    IServiceResult,
    IStoreExploreData,
    ITwoByTwo,
} from "../../Models/Models";
import { ITwoByTwoAxios } from "../index";

export class TwoByTwoAxios implements ITwoByTwoAxios {
    public Get2x2(): Promise<IServiceResult<ITwoByTwo>> {
        const promise = new Promise<IServiceResult<ITwoByTwo>>(
            (resolve, reject) => {
                axios.get<IServiceResult<ITwoByTwo>>("/Insights/TwoByTwo", {}).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }
        );

        return promise;
    }

    public ExploreStore(sid): Promise<IServiceResult<IStoreExploreData>> {
        const promise = new Promise<IServiceResult<IStoreExploreData>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<IStoreExploreData>>(`/Metric/StoreExplore?sid=${sid}`)
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }
}
